var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './SimpleGraph.styles.scss';
var SimpleGraph = function (_a) {
    var children = _a.children, _b = _a.percentage, percentage = _b === void 0 ? 0 : _b;
    var variant = '';
    if (percentage >= 0 && percentage <= 50) {
        variant = 'success';
    }
    if (percentage >= 51 && percentage <= 90) {
        variant = 'warning';
    }
    if (percentage >= 91) {
        variant = 'danger';
    }
    return (_jsxs("div", __assign({ className: "hefesto-simple-graph hefesto-simple-graph--".concat(variant) }, { children: [_jsx("span", __assign({ className: "hefesto-simple-graph__value" }, { children: children })), _jsx("div", __assign({ className: "hefesto-simple-graph__bar-wrapper" }, { children: _jsx("span", { "data-testid": "simpleGraphBar", className: "hefesto-simple-graph__bar", style: { width: "".concat(percentage > 100 ? 100 : percentage, "%") } }) }))] })));
};
export default SimpleGraph;
